import React from "react";
import { StyleSheet } from "react-native";
import { Text, View } from "@components/atoms/Themed";
import Spacer from "@components/atoms/Spacer";
import Fonts from "@constants/Fonts";
import Colors from "@constants/Colors";
import BackHome from "@components/organisms/Fallback/FallbackBackHome";

type ErrorDetails = {
  code?: string;
  message?: string;
  details?: {
    statusCode?: number;
    statusText?: string;
    originalError?: string;
    timestamp?: string;
  };
};

type Props = {
  error?: ErrorDetails;
};

// eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
export default function FallbackServiceDown({ error }: Props) {
  return (
    <>
      <Spacer height={50} />
      <View style={styles.textArea}>
        <Text style={styles.caption}>
          InfluencerWorksをご利用ありがとうございます。
          {"\n"}
          ただいまサービスに接続しにくい状況となっています。
          しばらく時間を開けてから「ページ再読み込み」を押してください。
          {"\n"}
          ご迷惑をおかけし申し訳ございませんが、よろしくお願いします。
        </Text>

        {/* {error?.details != null && (
          <>
            <Spacer height={20} />
            <View style={styles.errorDetails}>
              {error.details.statusCode != null && (
                <RNText style={styles.errorDetailText}>
                  ステータスコード: {error.details.statusCode}
                </RNText>
              )}
              {error.details.statusText != null && (
                <RNText style={styles.errorDetailText}>
                  ステータス: {error.details.statusText}
                </RNText>
              )}
              {error.details.originalError != null && (
                <RNText style={styles.errorDetailText}>
                  エラー内容: {error.details.originalError}
                </RNText>
              )}
              {error.details.timestamp != null && (
                <RNText style={styles.errorDetailText}>
                  発生時刻:{" "}
                  {new Date(error.details.timestamp).toLocaleString("ja-JP")}
                </RNText>
              )}
            </View>
          </>
        )} */}
      </View>
      <Spacer height={30} />
      <BackHome />
    </>
  );
}

const styles = StyleSheet.create({
  textArea: {
    paddingHorizontal: 16,
  },
  logoWrapper: {
    alignItems: "center",
  },
  squareIcon: {
    width: "100%",
    maxWidth: 390,
    height: 58,
  },
  caption: {
    ...Fonts.lr130,
  },
  errorDetails: {
    backgroundColor: "#FFF8F0",
    padding: 12,
    borderRadius: 6,
    borderLeftWidth: 3,
    borderLeftColor: Colors.orange,
    borderWidth: 1,
    borderColor: "#FFE0B2",
  },
  errorDetailText: {
    ...Fonts.sr100,
    color: "#333333",
    marginBottom: 4,
  },
});
